import API from '@/api/'


export const list = ({ commit, state }, params=null) => {
  const newParams = params ?? {max: state.max, offset: state.offset, sort: state.sort, order: state.order };
  //console.log(`action.organization.list: newParams = ${JSON.stringify(newParams)}`);
  return new Promise((resolve) => {
    API.member.list(newParams).then(res => {
      const {max, offset} = newParams;
      if (res.status === 200) {
        commit(`SET_LIST`, res.data[0]);
        commit(`SET_TOTAL`, res.data[1], );
        if (offset !== undefined) {
          commit(`SET_OFFSET`, offset, );
        }
        if (max !== undefined) {
          commit(`SET_MAX`, max, );
        }
        resolve(res)
      }
    })
  })
}

export const add = (_, params) => {
  delete params.checkPassword;
  return new Promise((resolve) => {
    API.member.add(params).then(res => {
      if (res.status === 201) {
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }

    })
  })
}
export const update = (_, params) => {
  delete params.checkPassword;
  return new Promise((resolve) => {
    API.member.update(params).then(res => {
      if (res.status === 200) {
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }

    })
  })
}
export const remove = (_, params) => {
  return new Promise((resolve) => {
    API.member.remove(params).then(res => {
      if (res.status === 200) {
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }

    })
  })
}
export const reset = (_, params) => {
  return new Promise((resolve) => {
    API.member.reset(params).then(res => {
      if (res.status === 201) {
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }

    })
  })
}
export const clear = ({ commit }) => {
  return new Promise((resolve) => {
    commit(`member/CLEAR`, {
      root: true
    });
    resolve();
  })
}
export default {
  list,
  add,
  update,
  remove,
  clear,
  reset
};
